// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date)
		});

	});

	window.onload = function() {
		scrollDownAction(80, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

	let openMenuButton = document.getElementById('menuButton');
	let closeMenuButton = document.getElementById('closeMenu');
	let menuSection = document.getElementById('menu');
	if(openMenuButton){
		openMenuButton.addEventListener('click', () => { 
			menuSection.classList.add("open");
		});
	}
	if(closeMenuButton){
		closeMenuButton.addEventListener('click', () => { 
			menuSection.classList.remove("open");
		});
	}
	setCountersZero();
	const counterElements = document.querySelectorAll(".statistics__text , .heat-map__text");

	function obCallBack(entries) {
		entries.forEach((entry) => {
			const { target } = entry;
			if (!entry.isIntersecting) return;
			countingUpNumbers()
			counterObserver.unobserve(target);
		});
	}

	const counterObserver = new IntersectionObserver(obCallBack, { threshold: 0.3 });
	counterElements.forEach((counterElem) => counterObserver.observe(counterElem));

}());
function setCountersZero(){
	document.querySelectorAll('.statistics__text .number , .heat-map__text .number').forEach((element) =>{
		let matchesString = element.textContent.match(/[^0-9]+/);
		let matchesNumber = element.textContent.match(/(\d+)/);
		let stringAdded = '';
		if (matchesString) {
			stringAdded = matchesString[0];
		}
		if (matchesNumber) {
			let topNumber = parseInt(matchesNumber[0]);
			element.setAttribute('top-number' , topNumber)
		}

		stringAdded = stringAdded.replace(/\+/g, '<span>+</span>');

		element.innerHTML = `0${stringAdded}`;
	});
}
function countingUpNumbers(){
	document.querySelectorAll('.statistics__text .number , .heat-map__text .number').forEach((element) =>{
		let matchesString = element.textContent.match(/[^0-9]+/);
		let currentNumber = 0;
		let topNumber  = parseInt(element.getAttribute('top-number'));
		let stringAdded =  '';
		if (matchesString) {
			stringAdded = matchesString[0];
		}
		const interval = setInterval(()=>{
			currentNumber += 1;
			if(  topNumber < currentNumber ){
				clearInterval(interval);
			}else{
				stringAdded = stringAdded.replace(/\+/g, '<span>+</span>');
				element.innerHTML = `${ currentNumber }${stringAdded}`;
			}
		} , 7);
	});
}

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}